import {
  VinoDataImage,
  generateStorefrontImage,
} from "../utils/generate-storefront-image";

import { LinkTo } from "../types";
import { TwoUpBlock, TwoUpDark } from "../components/blocks/two-up-block";

interface ContentfulContentTileProps {
  title: string;
  image: VinoDataImage;
  bodyText?: string;
  primaryCta: {
    buttonColour: string;
    buttonBorderColor: string;
    buttonTextColor: string;
    buttonHoverBorderColor?: string;
    buttonHoverBackgroundColor?: string;
    buttonHoverTextColor?: string;
    label: string;
    linkTo: LinkTo;
  };
}

interface ContentfulTwoUpBlockProps {
  __typename: string;
  backgroundColor: string;
  layout: string;
  title: string;
  tiles: Array<ContentfulContentTileProps>;
}

const test = ({ __typename }: ContentfulTwoUpBlockProps): boolean =>
  __typename === "VinoData_TwoUpBlock";

const create = (data: ContentfulTwoUpBlockProps): JSX.Element => {
  const transformedData = {
    ...data,
    layout: data.layout as "Two Up" | "Two Up Dark",
    tiles: data.tiles.map((tile) => ({
      ...tile,
      image: generateStorefrontImage(tile.image, {}),
    })),
  };

  return data.layout === "Two Up Dark" ? (
    <TwoUpDark {...transformedData} />
  ) : (
    <TwoUpBlock {...transformedData} />
  );
};

export default { test, create };
